import { h } from 'preact';

export const MoviePlatformHeader = (props) => (
	<svg width="164" height="92" viewBox="0 0 164 92" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="164" height="92" rx="4" fill="#0E0E0E" stroke="none" />
		<rect x="0.5" y="0.5" width="163" height="91" rx="3.5" stroke="black" stroke-opacity="0.05" />
		<rect x="12" y="12" width="12" height="12" rx="6" fill="white" stroke="none" />
		<rect x="28" y="17" width="12" height="2" fill="white" stroke="none" />
		<rect x="44" y="17" width="12" height="2" fill="white" stroke="none" />
		<rect x="60" y="17" width="12" height="2" fill="white" stroke="none" />
		<rect x="76" y="17" width="12" height="2" fill="white" stroke="none" />
		<rect x="40" y="64" width="40" height="16" rx="8" fill="#1748F6" stroke="#1748F6" />
		<rect x="84.5" y="64.5" width="39" height="15" rx="7.5" stroke="white" />
	</svg>
);

export const LocalMovieHeader = (props) => (
	<svg width="164" height="92" viewBox="0 0 164 92" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="164" height="92" rx="4" fill="#0E0E0E" stroke="none" />
		<rect x="0.5" y="0.5" width="163" height="91" rx="3.5" stroke="black" stroke-opacity="0.05" />
		<rect width="164" height="56" fill="url(#paint0_linear_8259_335329)" fill-opacity="0.2" stroke="none" />
		<rect x="12" y="12" width="12" height="12" rx="6" fill="white" stroke="none" />
		<rect x="28" y="17" width="12" height="2" fill="white" stroke="none" />
		<rect x="44" y="17" width="12" height="2" fill="white" stroke="none" />
		<rect x="60" y="17" width="12" height="2" fill="white" stroke="none" />
		<rect x="76" y="17" width="12" height="2" fill="white" stroke="none" />
		<rect x="12" y="64" width="40" height="16" rx="8" fill="#1748F6" stroke="#1748F6" />
		<rect x="56.5" y="64.5" width="39" height="15" rx="7.5" stroke="white" />
		<defs>
			<linearGradient id="paint0_linear_8259_335329" x1="82" y1="0" x2="82" y2="56" gradientUnits="userSpaceOnUse">
				<stop offset="0.798077" stop-color="white" />
				<stop offset="1" stop-color="white" stop-opacity="0" />
			</linearGradient>
		</defs>
	</svg>
);

export const LinkOutHeader = (props) => (
	<svg width="164" height="92" viewBox="0 0 164 92" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="164" height="92" rx="4" fill="#0E0E0E" stroke="none" />
		<rect x="0.5" y="0.5" width="163" height="91" rx="3.5" stroke="black" stroke-opacity="0.05" />
		<path d="M85 37H91L91 43M91 37L83 45M80 39H77.8C76.1198 39 75.2798 39 74.638 39.327C74.0735 39.6146 73.6146 40.0735 73.327 40.638C73 41.2798 73 42.1198 73 43.8V50.2C73 51.8802 73 52.7202 73.327 53.362C73.6146 53.9265 74.0735 54.3854 74.638 54.673C75.2798 55 76.1198 55 77.8 55H84.2C85.8802 55 86.7202 55 87.362 54.673C87.9265 54.3854 88.3854 53.9265 88.673 53.362C89 52.7202 89 51.8802 89 50.2V48" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);